export const sessionIdentifier = `session_web_${process.env.NEXT_PUBLIC_BUILD_ENV}`;
